module.exports = __webpack_public_path__ + "static/media/spinach1.d8a6fa5e.png";